import {Action} from "@ngrx/store";

export const LOAD_ZONE: string = '[zone] Load Zone';
export const LOAD_ZONE_SUCCESS: string = '[zone] Load Zone Success';
export const LOAD_ZONE_FAIL: string = '[zone] Load Zone Fail';


export class LoadZone implements Action {

  readonly type: string = LOAD_ZONE;
  constructor(public payload: {
    zoneId: any
  }) {}

}

export class LoadZoneSuccess implements Action {

  readonly type: string = LOAD_ZONE_SUCCESS;
  constructor(public payload: {
    zoneId: number,
    entities:  any,
  }) {}

}

export class LoadZoneFail implements Action {

  readonly type: string = LOAD_ZONE_FAIL;

  constructor(public payload: string) {
  }
}



export type ZoneAction = LoadZone | LoadZoneSuccess | LoadZoneFail;
